module.exports = __webpack_public_path__ + "img/about-2.08687f82.png";